module.exports = __webpack_public_path__ + "media/recipes/75-4d959d86.png";